module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.91156ba4.woff2";